import {post} from '../utils/request'

export default {
    getAll(query, page, pageSize) {
        return post("/admin/account/list", {...query, page, pageSize});
    },
    findById: function (id) {
        return post("/admin/account/show", {id});
    },
    create: function (account) {
        return post("/admin/account/create", account);
    },
    update: function (account) {
        return post("/admin/account/update", account);
    },

    deleteById: function (id) {
        return post("/admin/account/delete", {id});
    },
}
